'use strict';

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

exports.camelToDash = camelToDash;
//# sourceMappingURL=camel-to-dash.cjs.map
